import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {AddLessonSuccessResponse} from "../../../types/lessons/add-lessons/addLessonsSchema";
import {setErrors, setSuccess} from "../../../slice/groups/set-lessons/setLessons";
import {setError} from "../../../slice/addLessonSlice";


export const fetchUpdateLesson = createAsyncThunk(
    "lessons/updateLesson",
    async ({lessonsId, formData}: { lessonsId: string | undefined; formData: FormData }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.put<AddLessonSuccessResponse>(
                `/api/lessons/${lessonsId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(setSuccess({success: response.data.success}))
                return response.data;
            } else {
                thunkAPI.dispatch(setErrors(response.data));
                console.error("Ошибка при обновлении урока:", response.data.error);
                // return thunkAPI.rejectWithValue(response.data.error);
            }
        } catch (error) {
            // Обработка ошибок
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
